module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/list.component.css
// module id = ./src/app/views/patients/list.component.css
// module chunks = main